/*
 * @Author: wendong
 * @Date: 2020-06-19 14:39:14
 * @Last Modified by: wendong
 * @Last Modified time: 2020-06-28 16:43:42
 * 抽屉
 */
import React, { useCallback } from "react";
import ShadowBox from "../shadow/index";
import { Transition } from "react-transition-group";
import style from "./styles.module.scss";

const directionOpt = {
  right: "right",
  left: "left",
  top: "top",
  bottom: "bottom",
  center: "center",
};

const directionStyle: any = {
  top: {
    top: 0,
    left: 0,
    right: 0,
  },
  bottom: {
    bottom: 0,
    left: 0,
    right: 0,
  },
  right: {
    right: 0,
    top: 0,
    bottom: 0,
  },
  left: {
    left: 0,
    top: 0,
    bottom: 0,
  },
  center: {
    left: "50%",
    top: "50%",
    bottom: 0,
  },
};

const getStyle = (
  direction: any,
  openExpandSize: any,
  closeExpandSize: any
) => {
  let position = directionStyle[direction];
  switch (direction) {
    case directionOpt.right:
      return {
        position,
        transform: {
          open: {
            translateX: `${100 - openExpandSize}%`,
          },
          close: {
            translateX: `${100 - closeExpandSize}%`,
          },
        },
      };
    case directionOpt.left:
      return {
        position,
        transform: {
          open: {
            translateX: `${openExpandSize - 100}%`,
          },
          close: {
            translateX: `${closeExpandSize + -100}%`,
          },
        },
      };
    case directionOpt.top:
      return {
        position,
        transform: {
          open: {
            translateY: `${openExpandSize - 100}%`,
          },
          close: {
            translateY: `${closeExpandSize + -100}%`,
          },
        },
      };
    case directionOpt.bottom:
      return {
        position,
        transform: {
          open: {
            translateY: `${100 - openExpandSize}%`,
          },
          close: {
            translateY: `${100 - closeExpandSize}%`,
          },
        },
      };
    case directionOpt.center:
      return {
        position,
        transform: {
          open: {
            translate: `-50%, -50%`,
          },
          close: {
            translate: `100%, 100%`,
          },
        },
      };
  }
};

export default function Drawer({
  // 打开方向
  direction = "right",
  // 打开后展示总大小的百分比
  openExpandSize = "100",
  // 关闭后展示总大小的百分比，默认0
  closeExpandSize = "0",
  width = "70%",
  height,
  maxHeight = "100%",
  zIndex = "100",
  status = false,
  click,
  clickShadowAutoClose = false,
  children,
  showMask = true,
}: any) {
  const getCurrentStyle: any = useCallback(() => {
    return getStyle(direction, openExpandSize, closeExpandSize);
  }, [direction, openExpandSize, closeExpandSize]);

  function clickShadow() {
    if (clickShadowAutoClose) {
      click && click(false);
    }
  }

  function beforeEnter(el: any) {
    el.style["transition-duration"] = 0;
    const styles = { ...getCurrentStyle().transform.close };

    for (let key in styles) {
      el.style["transform"] = `${key}(${styles[key]})`;
    }
  }

  function enter(el: any) {
    el.style["transition-duration"] = "225ms";
    const styles = { ...getCurrentStyle().transform.open };

    for (let key in styles) {
      el.style["transform"] = `${key}(${styles[key]})`;
    }
  }

  function leave(el: any) {
    el.style["transition-duration"] = "225ms";
    const styles = { ...getCurrentStyle().transform.close };

    for (let key in styles) {
      el.style["transform"] = `${key}(${styles[key]})`;
    }
  }

  return (
    <div>
      {showMask && (
        <ShadowBox status={status} click={() => clickShadow()}></ShadowBox>
      )}
      <Transition
        onEnter={beforeEnter}
        onEntering={enter}
        // onEntered={this.onEntered}
        //@ts-ignore
        onExit={leave}
        // onExiting={leave}
        // onExited={this.onExited}
        in={status}
        // 为true 代表退出的时候移除dom
        unmountOnExit={true}
        timeout={225}
      >
        <div
          className={style["drawer-container"]}
          style={{
            width: width,
            height: height ? height : "auto",
            zIndex: zIndex,
            maxHeight: maxHeight,
            ...getCurrentStyle().position,
          }}
        >
          {children}
        </div>
      </Transition>
    </div>
  );
}
